<script setup lang="ts">

</script>

<template>
  <div>
    <h2>404 - Not Found</h2>
  </div>
</template>

<style scoped>

</style>